import { replacePlaceholders } from '@vfde-sails/utils';

/**
 * Returns the tauschbonus subline
 * @param template The string template
 * @param tauschbonusValue The tauschbonus value
 * @returns The replaced subline string
 */
const getTauschbonusSubline = (template: string, tauschbonusValue: number | string) =>
    tauschbonusValue ? replacePlaceholders(
        template || '',
        {
            tauschbonusValue: `${tauschbonusValue}`,
        },
    ) : '';

export default getTauschbonusSubline;
